import React from "react";
import { Route, Switch } from "react-router-dom";
import SummaryView from "./pages/SummaryView"
import IVDocumentSelection from './pages/IVDocumentSelection'
import {FormProvider, useForm} from 'react-hook-form';

enum PATHS {
  home = '/',
  IVDocumentSelection = '/verification/document-selection'
}

function Routes() {
  const methods = useForm();
  const getRoutes = () => {
    return (
      <Switch>
        <Route exact path={PATHS.home} >
          <SummaryView />
        </Route>
        <Route path={PATHS.IVDocumentSelection} >
        <FormProvider {...methods}>
          <IVDocumentSelection />
        </FormProvider>
        </Route>
      </Switch>
    );
  };
  return <>{getRoutes()}</>;
}
export {PATHS}
export default Routes;
